import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import {withRouter} from 'react-router'
import withOrganization from '../../../../Decorators/withOrganization'
import PropTypes from 'prop-types'
import {Form, Field} from 'simple-react-form'
import fileUpload from 'App/helpers/fields/fileUpload'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

@withOrganization
@withMessage
@withMutation(
  gql`
    mutation updateOrganization($organizationId: ID, $logo: FileInput) {
      updateOrganization(organizationId: $organizationId, logo: $logo) {
        name
        logo {
          url
        }
      }
    }
  `
)
@withRouter
export default class Main extends React.Component {
  state = {}
  static propTypes = {
    showMessage: PropTypes.func,
    router: PropTypes.object,
    organization: PropTypes.object,
    updateOrganization: PropTypes.func
  }

  @autobind
  async save() {
    this.setState({loading: true})
    try {
      await this.props.updateOrganization(
        {
          organizationId: this.props.organization._id,
          logo: this.state.logo
        },
        {
          refetchQueries: ['organization']
        }
      )
      this.props.showMessage('Organización Actualizada')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3>{this.props.organization.name}</h3>
          </div>
          <div className="content">
            <Form
              state={this.state}
              onSubmit={this.save}
              ref={form => (this.form = form)}
              onChange={changes => this.setState(changes)}
            >
              <div className="label">Logo</div>
              <Field fieldName="logo" label="File" {...fileUpload} />
            </Form>
            <br />
            <Button
              loading={this.state.loading}
              primary
              onClick={() => this.form.submit()}
              className={styles.button}
            >
              Guardar
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Organizations/OrganizationInfo/Main/index.js